<template>
  <component :is="component"></component>
</template>
<script>

import Func53 from '@/views/53/Func53Listagem'

export default {
  name: 'Func53',
  data () {
    return {
      component: Func53
    }
  }
}
</script>
